import { CreateNaturalPersonCommandDto } from 'api/actor';
import { ReferentialKey } from 'api/referential';
import { LegalEntityContactFormValues } from 'features/new-actor/types/legalEntityContactFormValues';
import { NewGuidPrefix } from 'helpers/generateGUID';

export function mapLegalEntityContactFormValues(
  values: LegalEntityContactFormValues,
  referentialsData: any,
): CreateNaturalPersonCommandDto {
  const findReferentialId = (referentialType: ReferentialKey, code: string): string => {
    const item = referentialsData[referentialType]?.find((item: any) => item.code === code);
    return item?.id || '';
  };

  const createAddress = () => ({
    line1: values.address,
    line2: (values.additionalAddress || '').trim(),
    line3: undefined,
    zipCode: values.postalCode,
    city: values.city,
    country: values.country,
    formattedAddress: `${values.address},${values.city},${values.country}`,
    latitude: values.latitude || undefined,
    longitude: values.longitude || undefined,
    googlePlaceId: values.googlePlaceId || undefined
  });

  const isValidId = (id: string | undefined): boolean => {
    return Boolean(id && !id.includes(NewGuidPrefix));
  };

  const result: CreateNaturalPersonCommandDto = {
    civilityId: findReferentialId(ReferentialKey.Civility, values.civility),
    nationalityId: findReferentialId(ReferentialKey.Nationality, values.nationality),
    companyRole: findReferentialId(ReferentialKey.CompanyRole, values.companyRole),
    lastName: values.lastName,
    firstName: values.firstName,
    birthName: values.birthName,
    phone: values.phone,
    email: values.email,
    birthDate: new Date(values.birthDate),
    birthCountryId: findReferentialId(ReferentialKey.Country, values.birthCountry),
    taxResidenceCountryId: findReferentialId(ReferentialKey.Country, values.taxResidenceCountryId),
    isPPE: values.isPPE,
    address: createAddress()
  };

  if (isValidId(values.id)) {
    result.id = values.id;
  }

  return result;
}
